import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

var CustomPortal = function (_PureComponent) {
  _inherits(CustomPortal, _PureComponent);

  function CustomPortal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CustomPortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CustomPortal.__proto__ || _Object$getPrototypeOf(CustomPortal)).call.apply(_ref, [this].concat(args))), _this), _this.node = null, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CustomPortal, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.node) {
        ReactDOM.unmountComponentAtNode(this.node);
        document.body.removeChild(this.node);
      }

      this.node = null;
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.node) {
        this.node = document.createElement('div');
        this.node.setAttribute('data-test-id', 'Portal');
        document.body.appendChild(this.node);
      }
      ReactDOM.unstable_renderSubtreeIntoContainer(this, React.createElement(
        'div',
        null,
        this.props.children
      ), this.node);
      return null;
    }
  }]);

  return CustomPortal;
}(PureComponent);

CustomPortal.propTypes = {
  /** The Portal children */
  children: PropTypes.node
};
export default CustomPortal;